import React from "react";
import { Form } from "react-final-form";
import { makeValidate } from "mui-rff";
import { Grid, Button } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

export default function CustomForm({
  schema,
  fields,
  payload,
  error,
  submitLabel,
  onSubmit,
  submitSize,
  pristine,
  submitClass,
  submitting,
}) {
  const validate = makeValidate(schema);
  return (
    <Form
      onSubmit={onSubmit}
      initialValues={payload}
      validate={validate}
      render={({ handleSubmit, pristine: p, values }) => (
        <form onSubmit={handleSubmit} noValidate>
          <Grid container alignItems="flex-start" spacing={2}>
            {fields(values).map(
              (item, idx) =>
                !item.hidden && (
                  <Grid item xs={item.size} key={idx}>
                    {item.field}
                  </Grid>
                )
            )}
            {error && (
              <Grid item xs={12}>
                <Alert variant="filled" severity="error">
                  {error}
                </Alert>
              </Grid>
            )}
            <Grid item xs={submitSize}>
              <Button
                fullWidth
                className={submitClass}
                variant="contained"
                color="primary"
                type="submit"
                disabled={submitting || (pristine && p)}
              >
                {submitLabel}
              </Button>
            </Grid>
          </Grid>
        </form>
      )}
    />
  );
}
